export { ResponsibleGamingHistory } from './ResponsibleGamingHistory';
